import { NgModule } from '@angular/core';
// TODO:Spartacus - // TODO:Spartacus - Variable translations has been removed and is no longer part of the public API. 
import { translationChunksConfig, translationsCs } from '@spartacus/assets';
import {
  AuthGuard,
  ConfigModule,
  FeaturesConfig,
  GlobalMessageConfig,
  GlobalMessageType,
  I18nConfig,
  NotAuthGuard,
  OccConfig,
  RoutingConfig,
  SiteContextConfig,
  provideConfig,
  provideDefaultConfig,
} from '@spartacus/core';
import { defaultB2bOccConfig } from '@spartacus/setup';
import {
  OutletPosition,
  defaultCmsContentProviders,
  layoutConfig,
  mediaConfig,
  provideOutlet,
} from '@spartacus/storefront';
import { FooterComponent } from '../customcomponents/footer/footer.component';
import { HeaderComponent } from '../customcomponents/header/header.component';
import { KbCartDetailsComponent } from '../customcomponents/kb-cart/kb-cart-details/kb-cart-details.component';
import { UpdatePasswordComponent } from '../customcomponents/kb-login/update-password/update-password.component';
import { KbProductCategoriesComponent } from '../customcomponents/kb-product-categories/kb-product-categories.component';
import { KbRegisterComponent } from '../customcomponents/kb-register/kb-register.component';
import { KbStoreFinderComponent } from '../customcomponents/store-finder/kb-store-finder/kb-store-finder.component';
import { CustomLayoutConfig } from '../layout/layout-config';
import { SecureGuard } from '../services/Guards/secure.service';
import { KbManageUsersComponent } from '../customcomponents/kb-mycompany-account/kb-manage-users/kb-manage-users.component';
import { CreateUserComponent } from '../customcomponents/kb-mycompany-account/create-user/create-user.component';
import { KbManageRegistrationComponent } from '../customcomponents/kb-mycompany-account/kb-manage-registration/kb-manage-registration.component';
import { EditUserComponent } from '../customcomponents/kb-mycompany-account/edit-user/edit-user.component';
import { EditRegistrationUserComponent } from '../customcomponents/kb-mycompany-account/edit-registration-user/edit-registration-user.component';
import { KbCoreLookupComponent } from '../customcomponents/kb-MyCoresNA/KbcoreLookup/KbcoreLookup.component';
import { OrderStatusListComponent } from '../customcomponents/kb-order-status/order-status-list/order-status-list.component';
import { OrderStatusDetailsComponent } from '../customcomponents/kb-order-status/order-status-details/order-status-details.component';
import { SavedShoppingCartComponent } from '../customcomponents/kb-saved-shopping-cart/saved-shopping-cart/saved-shopping-cart.component';
import { MyQuotesListComponent } from '../customcomponents/kb-my-quotes/my-quotes-list/my-quotes-list.component';
import { onlineOderingGuard } from '../services/Guards/onlineOrdering/online-odering.guard';
import { customTranslationChunksConfig, translationsOverwrite } from 'public/i18n/custom-translation-chunks';
declare module '@spartacus/core' {
  interface User {
    carts?: string[];
    card?: string;
    date?: string;
  }
  interface Product {
    breadcrumbs?: any;
  }

  interface SearchConfig {
    pageSize?: number;
    currentPage?: number;
    sort?: string;
    text?: string; //added new
  }
}
@NgModule({
  declarations: [],
  imports: [
    ConfigModule.withConfigFactory(naStoreGlobalMessageConfigFactory),
    ConfigModule.withConfig({
      pagination: {
        startLabel: 'common.search_Results_previousPage_link',
        previousLabel: 'common.search_Results_previousPage_link',
        nextLabel: 'common.search_Results_NextPage_link',
        rangeCount: 5,
        addNext: true,
        addEnd: false,
        addPrevious: true,
        addStart: false,
      },
    }),
  ],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<SiteContextConfig>{
      context: {
        urlParameters: ['country', 'language', 'currency'],
        currency: ['USD', 'CAD', 'MXN'],
        language: ['en', 'fr_CA', 'es_MX'],
        baseSite: ['NA'],
        country: ['US', 'CA', 'MX'],
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translationsCs,
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: translationsOverwrite,
        chunks: customTranslationChunksConfig,
      },
    }),
    provideConfig(<FeaturesConfig>{
      features: { level: '6.6' },
    }),
    provideConfig(CustomLayoutConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          // baseUrl: 'https://api-qa.b2bendix.com',
          endpoints: {
            user: 'kbhomepage/headerdata',
          },
        },
      },
    }),

    provideOutlet({
      id: 'cx-header',
      position: OutletPosition.REPLACE,
      component: HeaderComponent,
    }),

    provideOutlet({
      id: 'cx-footer',
      position: OutletPosition.REPLACE,
      component: FooterComponent,
    }),

    provideConfig(<RoutingConfig>{
      // custom routing configuration for e2e testing
      routing: {
        routes: {
          product: {
            paths: ['/c/:slug/p/:productCode', 'product/:productCode/:name', 'product/:productCode'],
            paramsMapping: { name: 'slug' },
          },
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        ProductCategoriesComponent: {
          component: KbProductCategoriesComponent,
          guards: [SecureGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        CustomerRegistrationFlexComponent: {
          component: KbRegisterComponent,
          guards: [NotAuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        UpdatePasswordFlexComponent: {
          component: UpdatePasswordComponent,
          guards: [NotAuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        CartComponent: {
          component: KbCartDetailsComponent,
          guards: [SecureGuard, onlineOderingGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        StoreFinderComponent: {
          component: KbStoreFinderComponent,
          guards: [SecureGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        RegistrationRequestFlexComponent: {
          component: KbManageRegistrationComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        CompanyUsersFlexComponent: {
          component: KbManageUsersComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        MyAdminUserCreateFlexComponent: {
          component: CreateUserComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        MyAdminUserEditFlexComponent: {
          component: EditUserComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        RegistrationRequestEditFlexComponent: {
          component: EditRegistrationUserComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        KbcoreLookUpPageFlexComponent: {
          component: KbCoreLookupComponent,
          guards: [SecureGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        OrderFlexComponent: {
          component: OrderStatusListComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        OrderDetailFlexComponent: {
          component: OrderStatusDetailsComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        SavedCartFlexComponent: {
          component: SavedShoppingCartComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        MyQuotesFlexComponent: {
          component: MyQuotesListComponent,
          guards: [SecureGuard, AuthGuard],
        },
      },
    }),
    provideConfig({
      cmsComponents: {
        bendixADBParagraphComponent: {
          guards: [SecureGuard],
        },
      },
    }),
    provideDefaultConfig({
      pageMeta: {
        resolvers: [
          {
            property: 'title',
            method: 'resolveTitle',
          },
          {
            property: 'heading',
            method: 'resolveHeading',
          },
          {
            property: 'breadcrumbs',
            method: 'resolveBreadcrumbs',
          },
          {
            property: 'description',
            method: 'resolveDescription',
          },
          {
            property: 'image',
            method: 'resolveImage',
          },
          {
            property: 'robots',
            method: 'resolveRobots',
          },
          {
            property: 'canonicalUrl',
            method: 'resolveCanonicalUrl',
          },
        ],
        canonicalUrl: {
          forceHttps: true,
          forceWww: false,
          removeQueryParams: true,
          forceTrailingSlash: true,
        },
      },
    }),
  ],
})
export class SpartacusConfigurationModule { }

function naStoreGlobalMessageConfigFactory(): GlobalMessageConfig {
  return {
    globalMessages: {
      [GlobalMessageType.MSG_TYPE_CONFIRMATION]: { timeout: 20000 },
      [GlobalMessageType.MSG_TYPE_INFO]: { timeout: 20000 },
      [GlobalMessageType.MSG_TYPE_ERROR]: { timeout: 20000 },
    },
  };
}
